export const ChatGroupUsages = {
    Chat: 'CHAT',
    Tasks: 'TASKS',
};
